import type { JobListing } from '~/components/blocks/JobListingTable/JobListingTable'

import useQuery from './use-sanity-query'

export default function useLatestJobs() {
  return (
    useQuery<JobListing[]>(`
  *[_type == "jobListing"] | order(publishDate desc){
    title,
    department,
    location,
    contractType,
    "currentSlug": slug.current
  }
  `) || []
  )
}
